import React from 'react';


const Gaming = () => {

    return (
        <div>
            <h1 className="text-center">Gaming</h1>
        </div>
    )
}

export default Gaming;